module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-container"
  }, [(_vm.value) ? _c('div', {
    staticClass: "video-wrapper"
  }, [_c('video', {
    attrs: {
      "src": _vm._f("ossurl")(_vm.value),
      "controls": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.addVideo
    }
  }, [_vm._v("上传视频")]), _vm._v(" "), _c('input', {
    ref: "videoInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "video/*"
    },
    on: {
      "change": _vm.uploadVideo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b2deab7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoUploader.vue
// module id = 814
// module chunks = 1